import clsx from 'clsx'
import { memo, useCallback } from 'react'

import useStyles from '../styles'

interface Props {
  getTrackingHistory: () => void
  getExpandedTrackingHistory: () => void
  isTrackingListExpanded: boolean
}
function SelectorButton({
  getTrackingHistory,
  getExpandedTrackingHistory,
  isTrackingListExpanded,
}: Props): JSX.Element {
  const classes = useStyles()

  const handleSummary = useCallback(() => {
    getTrackingHistory()
  }, [getTrackingHistory])

  const handleExpanded = useCallback(() => {
    getExpandedTrackingHistory()
  }, [getExpandedTrackingHistory])

  return (
    <div className={clsx(classes.selectorContainer, classes.inputHead, classes.boldTitle)}>
      <button
        className={
          isTrackingListExpanded
            ? clsx(classes.inactiveSelectorButton, classes.leftSelectorButton)
            : clsx(classes.activeSelectorButton, classes.leftSelectorButton)
        }
        onClick={handleSummary}
      >
        Summary
      </button>
      <button
        className={
          isTrackingListExpanded
            ? clsx(classes.activeSelectorButton, classes.rightSelectorButton)
            : clsx(classes.inactiveSelectorButton, classes.rightSelectorButton)
        }
        onClick={handleExpanded}
      >
        Expanded
      </button>
    </div>
  )
}

export default memo(SelectorButton)
